import { Product, FormatOption, Format } from './product';

// No s'utilitzen les llsites abstractes, només les llistes de productes
/*
export class AbstractListEntry{
    id : number
    name : string
    createddate : Date
    lines : number
    entrysubclass : string
}
*/

/*
export class AbstractLists {
    entries : number
    listentries : AbstractListEntry[]
}
*/


export class ShoppingListEntry{
    id : number
    name : string
    description : string
    createddate : Date
    lines : number
    weightgrams : number
    focused : boolean
}

export class ShoppingListLine {
    lineid : number
    linechecked : boolean
    quantity  : number
    nodeid : string
    product : Product
    productname : string
    formatservice : any
    notes : string
    discontinmued : boolean
    productidsucc : string
    weightgrams : number

    selected_options : FormatOption[];
    selected_serviceFormatOption :  FormatOption
    
    constructor(values: Object = {}){
        this.notes = '';
        this.product = null;
        this.formatservice = {};

        (<any>Object).assign(this, values);       
        this.product = new Product(this.product);
        this.selected_options = [];
        if (this.formatservice != null){
            Object.keys (this.formatservice).forEach (k => { 
                // this.selected_formats.set(k, this.selected_format[k]);
                let sf : Format = this.product.getServiceFormat();
                this.selected_serviceFormatOption = this.product.getServiceFormatOption(sf.format_id, this.formatservice[sf.format_id]);
                this.selected_options.push( this.product.getServiceFormatOption(k, this.formatservice[k]));
            });   
        }
    }

}

export class ShoppingList extends  ShoppingListEntry {
    lines : number;
    line : ShoppingListLine [];


    constructor(values: Object = {}){
        super();
        (<any>Object).assign(this, values);
        let lines = this.line.map(item => new ShoppingListLine(item));
        this.line = lines;
    }

}


export class ShoppingLists {
    entries : number
    listentries : ShoppingListEntry[]
}
